export default __webpack_public_path__ + "static/media/Cochin-Diocese.4f096b76.png";